import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import styled from "@emotion/styled";

const SortByWrapper = styled(Flex)`
  height: 32px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[3]}) {
    min-width: 200px;
  }
`;

const ResultContent = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  line-height: 1.43;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  margin-right: ${({ theme }) => theme.space[1]}px;
  flex-shrink: 0;
`;

export { SortByWrapper, ResultContent };
